import Cookies from 'js-cookie';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import useCookieQuery from '../../api/queries/useCookieQuery';
import { CookieCategoryType } from '../../api/types/cookies';
import CookieBar from './CookieBar';
import CookieModal from './CookieModal';
import './cookies.css';

function CookieWrapper() {
    const { i18n } = useTranslation('global', { keyPrefix: 'cookies' });
    const { isLoading, data } = useCookieQuery();
    const [stage, setStage] = useState(0);
    const config = data && data.config;

    const acknowledgeCookies = (categories: string[] = []) => {
        if (config) {
            const necessary = config.categoryTypes.filter(
                (cT: CookieCategoryType) => cT.active && cT.necessary,
            );
            const selected = [
                ...necessary.map((cT: CookieCategoryType) => cT.id),
                ...categories,
            ].filter((v, i, a) => a.indexOf(v) === i);
            const oldCookieString = Cookies.get(config.name);
            const newCookieString = selected.join(',');

            if (!oldCookieString || oldCookieString !== newCookieString) {
                Cookies.set(config.name, newCookieString, {
                    expires: config.validity,
                    sameSite: 'Lax',
                });
            }

            if (
                window.dataLayer &&
                typeof window.dataLayer.push === 'function'
            ) {
                const consent = config.categoryTypes
                    .filter((cT: CookieCategoryType) => cT.active)
                    .map((cT: CookieCategoryType) => [
                        cT.id,
                        selected.includes(cT.id) ? 'granted' : 'denied',
                    ]);

                window.dataLayer.push([
                    'consent',
                    'update',
                    Object.fromEntries(consent),
                ]);
            }
            setStage(2);
        }
    };

    if (
        isLoading ||
        !config ||
        !i18n.resolvedLanguage ||
        !config[i18n.resolvedLanguage] ||
        Cookies.get(config.name)
    )
        return null;

    return (
        <>
            {stage === 0 && (
                <CookieBar
                    allow={acknowledgeCookies}
                    data={config}
                    onSetup={() => setStage(1)}
                />
            )}
            {stage === 1 && (
                <CookieModal allow={acknowledgeCookies} data={config} />
            )}
        </>
    );
}

export default CookieWrapper;
